import {
  AssetsProvider,
  Image,
  Link,
  notDesktop,
  styled,
  useContextPath,
} from '@obvio/app'
import { WishlistButton } from '@obvio/template'
import { Grid, Stack } from '@obvio/ui'

import type { CATEGORY_DATA } from '@/pages/sklep/kategoria/[slug]'
import type { ReactElement } from 'react'

const ProductImg = styled.div`
  height: 26rem;
  width: 100%;
  position: relative;
  border-bottom: 1px solid ${(theme) => theme.stroke};
  :hover {
    border: 1px solid ${(theme) => theme.stroke};
  }
`

const Title = styled.span``

const StyledGrid = styled(Grid)`
  position: relative;
  @media ${notDesktop} {
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: auto;
  }
`

const Category = styled.span`
  font-weight: 500;
  font-size: 0.875rem;
  letter-spacing: 0.12em;
  color: ${(theme) => theme.colors.secondary};
`

const Element = styled(Stack)`
  position: relative;
`

const LikeButton = styled(WishlistButton)`
  background: ${(theme) => theme.stroke};
  margin-top: 0 !important;
`

const Price = styled.span`
  font-weight: 500;
  font-size: 0.875rem;
  color: ${(theme) => theme.colors.secondary};
`

type CategoryProductsProps = {
  products: CATEGORY_DATA['products']
}

export function CategoryProducts({
  products,
}: CategoryProductsProps): ReactElement {
  const ecommerceProduct = useContextPath('ecommerce.product')
  return (
    <StyledGrid
      templateColumns="repeat(3, minmax(0, 1fr))"
      templateRows="repeat(2, minmax(0, 1fr))"
      gap="medium"
    >
      {products.map((product) => (
        <Link href={`${ecommerceProduct}/${product.slug}`} key={product.id}>
          <Element kind="vertical" spacing="extraSmall">
            <ProductImg>
              <AssetsProvider path={`/sklep/produkt/${product.id}`}>
                <Image img={product.images[0]} />
              </AssetsProvider>
            </ProductImg>
            <Category>{product.category.title}</Category>
            <Title>{product.title}</Title>
            {product.price ? (
              <Price>{`${product.price.price / 100} ${
                product.price.currency
              }`}</Price>
            ) : null}
            <LikeButton productId={product.id} />
          </Element>
        </Link>
      ))}
    </StyledGrid>
  )
}
